<!-- src/views/DashboardView.vue -->
<template>
  <div id="app">
    Welcome
  </div>
</template>

<script>

export default {
};
</script>

<style>
/* Estilos globais */
</style>
